import TabPage from "./TabPage";

const ChallengesInfo = () => <TabPage tabKey="challenges" />;

export default ChallengesInfo;
